import React, { useState } from 'react';
import { Button, Chip, Icon, IconButton, Typography } from '@material-ui/core';
import useStyles from 'app/cluster-styles/useStyles';
import ScriptDialog from 'app/fuse-layouts/shared-components/ScriptDialog';
import SectionCard from './SectionCard';

export default function ProvisioningScriptSection({ form, setField, provider, fillHeight, disabled }) {
    const classes = useStyles();
    const [isScriptOpen, setScriptOpen] = useState(false);

    const script = form.provisionScript || '';

    const handleUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        e.target.value = '';
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = () => setField('provisionScript', reader.result);
    };

    return (
        <>
            <SectionCard icon="code" title="Provisioning Script" fillHeight={fillHeight}>
                <div className="flex items-center mb-2">
                    <div className="flex-grow">
                        <input
                            className={classes.uploadInput}
                            onChange={handleUpload}
                            id={`${provider}_upload-btn`}
                            type="file"
                            disabled={disabled}
                        />
                        <label htmlFor={`${provider}_upload-btn`}>
                            <Button
                                id={`${provider}_upload-label`}
                                component="span"
                                variant="contained"
                                className={classes.grayButton}
                                startIcon={<Icon>cloud_upload</Icon>}
                                disabled={disabled}
                            >
                                Upload Script
                            </Button>
                        </label>
                    </div>

                    {!script ? (
                        <Typography variant="body2" color="textSecondary">
                            No Script
                        </Typography>
                    ) : (
                        <div className="flex items-center">
                            <Chip
                                label="Script Uploaded"
                                color="primary"
                                size="small"
                                style={{ marginRight: '8px' }}
                            />
                            {!disabled && (
                                <IconButton size="small" onClick={() => setField('provisionScript', '')}>
                                    <Icon fontSize="small">delete</Icon>
                                </IconButton>
                            )}
                            <IconButton id="script-actions-view-button" size="small" onClick={() => setScriptOpen(true)}>
                                <Icon fontSize="small">visibility</Icon>
                            </IconButton>
                        </div>
                    )}
                </div>
            </SectionCard>
            <ScriptDialog
                open={isScriptOpen}
                onClose={() => setScriptOpen(false)}
                scriptContent={script}
            />
        </>
    );
}
